import React from "react";
import { Outlet } from "react-router-dom";

const Clients = () => {
  return <Outlet />;
};

export default Clients;
